import React from 'react';

export default function TermsAndConditions() {
    return (
        <div className="min-h-screen bg-gray-50 flex justify-center p-4">
            <div className="max-w-3xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="bg-primary-400 px-6 py-4">
                    <h1 className="text-2xl font-bold text-white">Terms &amp; Conditions</h1>
                </div>
                <div className="p-6 space-y-6 text-gray-600 font-medium leading-relaxed">
                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-700 mb-2">1. Introduction</h2>
                        <p>
                            Welcome to SAN Job Portal. These Terms and Conditions ("Terms")
                            govern your use of our website and services. By accessing or
                            using the portal, you agree to be bound by these Terms.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-700 mb-2">2. User Accounts</h2>
                        <p>
                            You must register for an account to use certain features. You
                            agree to provide accurate information and keep your password
                            confidential.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-700 mb-2">3. Usage Rules</h2>
                        <ul className="list-disc list-inside">
                            <li>No unauthorized scraping or data harvesting.</li>
                            <li>Respect the privacy of other users.</li>
                            <li>Do not post illegal or offensive content.</li>
                        </ul>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-700 mb-2">4. Intellectual Property</h2>
                        <p>
                            All content on this portal is our property or used with
                            permission. You may not reproduce or distribute without consent.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-700 mb-2">5. Limitation of Liability</h2>
                        <p>
                            We are not liable for any indirect or consequential damages
                            arising from your use of the portal.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-700 mb-2">6. Changes to Terms</h2>
                        <p>
                            We may update these Terms at any time. We’ll notify you of
                            major changes via email or on the site.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-700 mb-2">7. Contact Us</h2>
                        <p>
                            For questions, reach out to our support team at{' '}
                            <a href="mailto:info@santechnovation.com" className="text-primary-400 underline">
                                info@santechnovation.com
                            </a>.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}
